<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
    <div class="card">
        <div class="card-body">
            <form [formGroup]="lifeInsuranceInformation">
                <div class="row">
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="accountNumber">Account Number</label>
                        <input class="form-control text-dark" type="text" id="accountNumber" formControlName="accountNumber" autocomplete="off">
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="creditLifeCommissionRate">Credit Life Commission Rate</label>
                        <percent-input [id]="'creditLifeCommissionRate'" [control]="lifeInsuranceInformation.get('creditLifeCommissionRate')"></percent-input>
                    </div>
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="accidentHealthCommissionRate" class="text-nowrap">Accident Health Commission Rate</label>
                        <percent-input [id]="'accidentHealthCommissionRate'" [control]="lifeInsuranceInformation.get('accidentHealthCommissionRate')"></percent-input>
                    </div>
                    <div class="form-group col-md-4 col-sm-12">
                        <label for="otherFees">Additional Fees</label>
                        <currency-input [id]="'otherFees'" [control]="lifeInsuranceInformation.get('otherFees')"></currency-input>
                    </div>
                </div>
            </form>
            <div class="card-footer text-right">
                <button class="btn btn-sm btn-primary" (click)="saveLifeInsurance()" [disabled]="!lifeInsuranceInformation.valid || contactId == 0">Save</button>
                @if (calledFrom !== null) {
                    <button class="btn btn-sm btn-primary">Cancel &amp; Close</button>
                }
            </div>
        </div>
    </div>
    @if (calledFrom == null) {
        <div class="text-right">
            <button class="btn btn-sm btn-danger" (click)="deactivateRole()">Deactivate Role</button>
        </div>
    }
</div>
